var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOtcOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.187,
    height: 45,
    viewBox: "0 0 45.187 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OTC_Disabled_",
    "data-name": "OTC (Disabled)",
    transform: "translate(-87.496 -18.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M3.239,29.074A1.052,1.052,0,0,1,2.183,28.03V15.28H1.052A1.045,1.045,0,0,1,0,14.24V10.165a1.045,1.045,0,0,1,1.052-1.04h20.79V5.455A5.5,5.5,0,0,1,27.367,0h7.447a5.492,5.492,0,0,1,5.518,5.455v3.67h3.8a1.048,1.048,0,0,1,1.056,1.04V14.24a1.048,1.048,0,0,1-1.056,1.039H43V28.03a1.049,1.049,0,0,1-1.052,1.044Z",
    transform: "translate(87.496 34.524)",
    fill: "#8b9095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M14.05,19.222a1.036,1.036,0,0,1-.684-.257L7.207,13.6H2.526A2.531,2.531,0,0,1,0,11.065V2.526A2.529,2.529,0,0,1,2.526,0H16.144A2.529,2.529,0,0,1,18.67,2.526v8.543A2.529,2.529,0,0,1,16.144,13.6H15.093v4.584a1.034,1.034,0,0,1-.611.946A1.015,1.015,0,0,1,14.05,19.222ZM6.5,6.232A.745.745,0,0,0,6,7.524l2.2,2.021a.738.738,0,0,0,.5.2h.06a.752.752,0,0,0,.525-.28l3.472-4.409a.747.747,0,0,0-.129-1.047.743.743,0,0,0-1.041.124L8.612,7.9,7.009,6.43A.747.747,0,0,0,6.5,6.232Z",
    transform: "translate(89.655 18.598)",
    fill: "#8b9095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M394.938,79.684a5.037,5.037,0,1,0-5.037-5.037A5.043,5.043,0,0,0,394.938,79.684Z",
    transform: "translate(-276.288 -46.674)",
    fill: "#8b9095"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2772",
    "data-name": "Rectangle 2772",
    transform: "translate(112.168 39.318)",
    fill: "#8b9095",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.682,0h0a.682.682,0,0,1,.682.682V4.091a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V.682A.682.682,0,0,1,.682,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.364,
    height: 3.091,
    rx: 0.182,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2773",
    "data-name": "Rectangle 2773",
    transform: "translate(123.211 39.318)",
    fill: "#8b9095",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.682,0h0a.682.682,0,0,1,.682.682V4.091a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V.682A.682.682,0,0,1,.682,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.364,
    height: 3.091,
    rx: 0.182,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOtcOff);
export default __webpack_public_path__ + "static/media/ic-otcOff.0359605a.svg";
export { ForwardRef as ReactComponent };